'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductService = function () {
  function ProductService($http, Upload) {
    'ngInject';

    _classCallCheck(this, ProductService);

    this.$http = $http;
    this.Upload = Upload;
  }

  _createClass(ProductService, [{
    key: 'search',
    value: function search(query) {
      return this.$http.get('/odata/ProductOData', {
        params: _extends({
          $select: 'ProductId, ProductName',
          $top: query.take
        }, query.page && { $skip: query.calculateSkip() }, {
          $orderby: query.orderBy + ' ' + query.direction
        }, query.filter && { $filter: query.filter.toString() }, {
          $count: true
        })
      });
    }
  }, {
    key: 'searchProductsByName',
    value: function searchProductsByName(name) {
      return this.$http.get('/api/product/search_by_name?name=' + name);
    }
  }, {
    key: 'searchProductsByNameForCopy',
    value: function searchProductsByNameForCopy(name, isTreat) {
      return this.$http.get('/api/product/search_by_name_for_copy?name=' + name + '&isTreat=' + isTreat);
    }
  }, {
    key: 'getProduct',
    value: function getProduct(id) {
      return this.$http.get('/api/product/' + id);
    }
  }, {
    key: 'create',
    value: function create(product) {
      return this.$http.post('/api/product/', product);
    }
  }, {
    key: 'update',
    value: function update(product) {
      return this.$http.put('/api/product/' + product.ProductId, product);
    }
  }, {
    key: 'uploadLabel',
    value: function uploadLabel(productId, label) {
      return this.Upload.upload({
        url: '/api/product_label/' + productId,
        data: {
          label: label
        }
      });
    }
  }, {
    key: 'getLabel',
    value: function getLabel(id) {
      return this.$http.get('/api/product_label/' + id);
    }
  }, {
    key: 'getLabelDetails',
    value: function getLabelDetails(id) {
      return this.$http.get('/api/product_label/' + id + '/request');
    }
  }, {
    key: 'getAdministrationUnits',
    value: function getAdministrationUnits() {
      return this.$http.get('/api/product/container_types');
    }
  }, {
    key: 'getAdministrationUnitsForSupplements',
    value: function getAdministrationUnitsForSupplements() {
      return this.$http.get('/api/product/valid_container_types_for_supplements');
    }
  }, {
    key: 'getAdministrationUnitsForTreats',
    value: function getAdministrationUnitsForTreats() {
      return this.$http.get('/api/product/valid_container_types_for_treats');
    }
  }, {
    key: 'getFrequencies',
    value: function getFrequencies() {
      return this.$http.get('/api/product/get_frequency_type');
    }
  }, {
    key: 'getPlantParts',
    value: function getPlantParts() {
      return this.$http.get('/api/product/get_plant_part');
    }
  }, {
    key: 'getWeightUnits',
    value: function getWeightUnits() {
      return this.$http.get('/api/product/get_weight_unit');
    }
  }, {
    key: 'getHerbRatioFrom',
    value: function getHerbRatioFrom() {
      return this.$http.get('/api/product/get_herb_ratio_from');
    }
  }, {
    key: 'getHerbRatioTo',
    value: function getHerbRatioTo() {
      return this.$http.get('/api/product/get_herb_ratio_to');
    }
  }, {
    key: 'getHerbForms',
    value: function getHerbForms() {
      return this.$http.get('/api/product/get_herb_forms');
    }
  }, {
    key: 'signOff',
    value: function signOff(productId, signature) {
      return this.$http.post('/api/product/' + productId + '/sign', {
        productId: productId,
        signature: signature
      });
    }
  }, {
    key: 'getUnitsDisplay',
    value: function getUnitsDisplay(product) {
      if (product.ProductForm) {
        if (product.ProductForm.indexOf('(s)') !== -1) {
          return product.ProductForm.toLowerCase();
        }
        return product.ProductForm.toLowerCase() + 's';
      }

      return 'units';
    }
  }, {
    key: 'copyProduct',
    value: function copyProduct(copyToProduct, copyFromProduct, copyAreas) {
      var copiedProduct = _extends({}, copyToProduct, {
        Signature: null,
        SignDate: null
      });

      for (var i = 0; i < copyAreas.length; i += 1) {
        if (copyAreas[i] === 'Product Information') {
          copiedProduct = _extends({}, copiedProduct, this.copyInformation(copyFromProduct));
        }if (copyAreas[i] === 'Administrations') {
          copiedProduct = _extends({}, copiedProduct, this.copyAdministrations(copyFromProduct));
        }if (copyAreas[i] === 'Product Ingredients') {
          copiedProduct = _extends({}, copiedProduct, this.copyIngredients(copyFromProduct));
        }
        // if (copyAreas[i] === ('Usage Data')) {
        //   copiedProduct = {
        //     ...copiedProduct,
        //     ...this.copyUsageData(copyFromProduct)
        //   };
        // }
      }

      return copiedProduct;
    }
  }, {
    key: 'copyInformation',
    value: function copyInformation(product) {
      return {
        ProductCategoryIds: product.ProductCategoryIds,
        ProductName: product.ProductName,
        SKU: product.SKU,
        // make them supply a new date for the new version/reformulation  DateIntroduced: product.DateIntroduced,
        ProductForm: product.ProductForm,
        UnitPerContainer: product.UnitPerContainer,
        WarningNote: product.WarningNote,
        FeedingNote: product.FeedingNote,
        HasLoading: product.HasLoading,
        UPC: product.UPC,
        TakeAsNeeded: product.TakeAsNeeded,
        IsBulkQty: product.IsBulkQty,
        IsSample: product.IsSample,
        IsTreat: product.IsTreat
      };
    }
  }, {
    key: 'copyAdministrations',
    value: function copyAdministrations(product) {
      product.tblDoses = product.tblDoses || [];

      // eslint-disable-next-line no-restricted-syntax
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = product.tblDoses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var u = _step.value;

          u.DoseId = 0;
          u.ProductId = 0;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        tblDoses: product.tblDoses || []
      };
    }
  }, {
    key: 'copyIngredients',
    value: function copyIngredients(product) {
      product.tblProduct_UserIngredient = product.tblProduct_UserIngredient || [];

      // eslint-disable-next-line no-restricted-syntax
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = product.tblProduct_UserIngredient[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var u = _step2.value;

          u.Id = 0;
          u.ProductId = 0;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return {
        tblProduct_UserIngredient: product.tblProduct_UserIngredient
      };
    }

    // copyUsageData(product) {
    //   product.tblUsages = product.tblUsages || [];

    //   // eslint-disable-next-line no-restricted-syntax
    //   for (const u of product.tblUsages) {
    //     u.UsageId = 0;
    //     u.ProductId = 0;
    //   }

    //   return {
    //     tblUsages: product.tblUsages
    //   };
    // }

  }, {
    key: 'transformUsages',
    value: function transformUsages(productId, dateFirstSold, usages) {
      if (!dateFirstSold || !usages) {
        return [];
      }

      var validUsages = usages.filter(function (u) {
        return u.UsageYear >= dateFirstSold.getFullYear();
      });

      var curYear = new Date().getFullYear();

      var _loop = function _loop(i) {
        if (validUsages.some(function (u) {
          return u.UsageYear === i;
        }) === false) {
          validUsages.push({
            Encry: false,
            ProductId: productId || 0,
            Q1: null,
            Q2: null,
            Q3: null,
            Q4: null,
            UsageId: 0,
            UsageYear: i
          });
        }
      };

      for (var i = dateFirstSold.getFullYear(); i <= curYear; i += 1) {
        _loop(i);
      }

      return [].concat(_toConsumableArray(validUsages.sort(function (a, b) {
        return a.UsageYear - b.UsageYear;
      })));
    }

    // TODO: Refactor to OData call

  }, {
    key: 'getCategories',
    value: function getCategories() {
      return this.$http.get('/api/product_category/all');
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return this.$http.delete('/api/product/' + id);
    }
  }]);

  return ProductService;
}();

exports.default = ProductService;


// WEBPACK FOOTER //
// ./services/product.service.js